import { jsx as _jsx } from "react/jsx-runtime";
import { Outlet } from 'react-router-dom';
import { AuthProvider } from './contexts/authContext';
import { DarkModeProvider } from './contexts/darkModeContext';
import { SharePointAuthProvider } from './contexts/sharePointAuthContext';
/**
 * Root application component that provides global context providers
 * Wraps the application with Auth, DarkMode, and SharePoint auth contexts
 */ export default function App() {
    return /*#__PURE__*/ _jsx(AuthProvider, {
        children: /*#__PURE__*/ _jsx(DarkModeProvider, {
            children: /*#__PURE__*/ _jsx(SharePointAuthProvider, {
                children: /*#__PURE__*/ _jsx(Outlet, {})
            })
        })
    });
}
